/**
 * Admin view component to redirect to cloud-agenda view for a groupUser's certificate
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as studyActions from '../../study/studyActions.js';
import * as moduleCertificateActions from '../moduleCertificateActions.js';
import * as userModuleActions from '../../userModule/userModuleActions.js';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';

// import moduleCertificate components
import ModuleCertificateLayout from '../components/ModuleCertificateLayout.js.jsx';

class AdminSingleModuleCertificateRedirect extends Base {
  constructor(props) {
    super(props);
  }
  /*
   * NOTE: This is only a component to grab the group/study in order to redirect to the admin cert view in london. 
   */

  componentDidMount() {
    const { dispatch, match } = this.props;

    // fetch module certificate
    // fetch userModule associated with cert 
    // fetch group associated with userModule 

    // fetch group/study in order to get the organization and then reroute to london.
    if(match.params.studyId) {
      dispatch(studyActions.fetchSingleIfNeeded(match.params.studyId)).then((studyAction) => {
        if(studyAction.success) {
          const study = studyAction.item;
          window.location.replace(`${window.agendaUrl}/${study._organization}/${study._id}/admin/certificates/${match.params.moduleCertificateId}`);
        }
      })
    } 
  }

  render() {

    return (
      <ModuleCertificateLayout>
        <Helmet
          title={"Certificate of Completion"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h2>Loading...</h2>
            </div>
          </section>
        </div>
      </ModuleCertificateLayout>
    )
  }
}

AdminSingleModuleCertificateRedirect.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {

  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminSingleModuleCertificateRedirect)
);



// WEBPACK FOOTER //
// modules/moduleCertificate/views/AdminSingleModuleCertificateRedirect.js.jsx